import Dialog from '@material-ui/core/Dialog';
import Form from '../../../components/Form';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import FormField from '../../../components/FormField';
import { t } from 'ttag';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import React from 'react';

export const ReasonDialogForm = ({
  open,
  onAccept,
  onClose,
  showDateField,
}) => (
  <Dialog open={open} onClose={onClose}>
    <Form
      onSubmit={(data) => {
        onAccept(data);
      }}
      initial={{
        reason: '',
      }}
      errors={[]}
    >
      {({ data, change, errors, submit }) => (
        <>
          {showDateField ? (
            <DialogTitle>Введіть причину і дату зняття блокування</DialogTitle>
          ) : (
            <DialogTitle>Введіть причину</DialogTitle>
          )}
          <DialogContent>
            <DialogContentText>
              {showDateField ? (
                <FormField
                  fullWidth
                  type='date'
                  label={t`Виберіть дату`}
                  id='date'
                  name='date'
                  variant='outlined'
                  value={data.date}
                  errors={errors.date}
                  onChange={change}
                />
              ) : null}
              <FormField
                fullWidth
                type='text'
                margin='normal'
                label={t`Введіть текст`}
                id='reason'
                multiline
                rows={4}
                name='reason'
                variant='outlined'
                value={data.reason}
                errors={errors.reason}
                onChange={change}
              />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              style={{ margin: '20px 0 20px 0' }}
              margin='normal'
              type='button'
              variant='contained'
              color='primary'
              onClick={submit}
            >
              {t`Застосувати`}
            </Button>
            <Button onClick={onClose} color='primary'>
              {t`Відмінити`}
            </Button>
          </DialogActions>
        </>
      )}
    </Form>
  </Dialog>
);
